import { useEffect, useRef, useState } from "react";

export function useAppVersion(pollIntervalMs = 15 * 60 * 1000) {
  const [hasUpdate, setHasUpdate] = useState(false);
  const currentBuildId = useRef<string | null>(null);

  async function fetchBuildId() {
    try {
      const res = await fetch("/version.json", { cache: "no-store" });

      if (!res.ok) return;

      const { buildId } = await res.json();

      if (currentBuildId.current && currentBuildId.current !== buildId) {
        setHasUpdate(true);
      }

      currentBuildId.current = buildId;
    } catch (error) {}
  }

  useEffect(() => {
    fetchBuildId();

    const interval = setInterval(fetchBuildId, pollIntervalMs);

    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        fetchBuildId();
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [pollIntervalMs]);

  return { hasUpdate };
}
